import { axios } from '@/utils/request'

const api = {
  writeoff: '/order/writeoff',
  province: '/basicdata/province',
  city: '/basicdata/city',
  area: '/basicdata/area',
  orderType: '/basicdata/orderType',
  company: '/enterprise/management',
  question: '/order/question',
  orderProcess: '/order/orderProcess',
  remark: '/order/remark',
}
// 列表
export function queryOrderWriteOff(parameter) {
  return axios({
    url: api.writeoff + '/queryOrderWriteOff',
    method: 'get',
    params: parameter
  })
}
// 导出
export function exportWriteoff(parameter) {
  return axios({
    url: api.writeoff + '/exportWriteoff',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  })
}
// 省市区下拉
export function getSelectAllProvince(parameter) {
  return axios({
    url: api.province + '/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectCityName(parameter) {
  return axios({
    url: api.city + '/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getelectAreaName(parameter) {
  return axios({
    url: api.area + '/selectAreaName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 订单类型下拉
export function getOrderTypeList(parameter) {
  return axios({
    url: api.orderType + `/getList/${parameter}`,
    method: 'get',
  })
}
// 企业下拉框
export function getSlectCombox(parameter) {
  return axios({
    url: api.company + '/selectCombox',
    method: 'get',
    params: parameter
  })
}
// 销单状态
export function updateSaleOrder(parameter) {
  return axios({
    url: '/order/writeoff/updateSaleOrder',
    method: 'get',
    params: parameter
  })
}
// 订单负责人
export function findByDeptId(parameter) {
  return axios({
    url: `/system/user/findByDeptId/${103}`,
    method: 'get',
    params: parameter
  })
}
// 所有题目
export function firstList(parameter) {
  return axios({
    url: api.question + '/firstList',
    method: 'get',
    params: parameter
  })
}
// 提交答题
export function insert(parameter) {
  return axios({
    url: api.question + '/insert',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 订单完成
export function completeOrder(parameter) {
  return axios({
    url: api.orderProcess + '/completeOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 订单备注信息
export function addOrderRemark(parameter) {
  return axios({
    url: api.remark + '/addOrderRemark',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 修改核销人
export function editWriteoffUserCharge(parameter) {
  return axios({
    url: api.writeoff + '/editWriteoffUserCharge',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 查看是否为初次核销
export function selectIsSecond(parameter) {
  return axios({
    url: '/order/question/selectIsSecond',
    method: 'get',
    params: parameter
  })
}
// 查看二次考核
export function getQuestion(parameter) {
  return axios({
    url: `/order/question/get/${parameter} `,
    method: 'get',
  })
}